import { computed, ref } from 'vue';
import api from '@/api';

export interface RoleOrSkill {
	label: string;
	slug: string;
	published: boolean;
}

export type ServicesListType = {
	ctaLabel: string;
	services: RoleOrSkill[];
	kind?: 'role' | 'skill';
};

const roles = ref<RoleOrSkill[]>([]);
const skills = ref<RoleOrSkill[]>([]);
const isLoaded = ref(false);
let loadPromise: Promise<void> | null = null;

async function ensureLoaded() {
	if (isLoaded.value) return;
	if (!loadPromise) {
		loadPromise = (async () => {
			const data = await api.fetchRolesAndSkills();
			roles.value = data.roles;
			skills.value = data.skills;
			isLoaded.value = true;
		})();
	}
	await loadPromise;
}

const servicesList = computed((): ServicesListType[] => [
	{ ctaLabel: 'Hire by role', kind: 'role', services: roles.value },
	{ ctaLabel: 'Hire by skills', kind: 'skill', services: skills.value },
]);

export function useRolesAndSkills() {
	ensureLoaded().catch(() => {});
	return { roles, skills, isLoaded, ensureLoaded, servicesList };
}

export function getRoleSkillUrl(
	role: RoleOrSkill,
	kind: string = 'role',
): string {
	const registerUrl = route('clients.register');

	return `${registerUrl}?${kind}=${encodeURIComponent(role.slug)}`;
}
